/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Export_Report_Aria_LabelInputs */

const en_style_guide_export_report_aria_label = /** @type {(inputs: Style_Guide_Export_Report_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Report`)
};

const fr_style_guide_export_report_aria_label = /** @type {(inputs: Style_Guide_Export_Report_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter le rapport`)
};

const de_style_guide_export_report_aria_label = /** @type {(inputs: Style_Guide_Export_Report_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportbericht`)
};

const it_style_guide_export_report_aria_label = /** @type {(inputs: Style_Guide_Export_Report_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapporto di esportazione`)
};

const ru_style_guide_export_report_aria_label = /** @type {(inputs: Style_Guide_Export_Report_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отчет об экспорте`)
};

const es_style_guide_export_report_aria_label = /** @type {(inputs: Style_Guide_Export_Report_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe de exportación`)
};

const zh_cn2_style_guide_export_report_aria_label = /** @type {(inputs: Style_Guide_Export_Report_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口报告`)
};

const ja_style_guide_export_report_aria_label = /** @type {(inputs: Style_Guide_Export_Report_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートレポート`)
};

const hi_style_guide_export_report_aria_label = /** @type {(inputs: Style_Guide_Export_Report_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात रिपोर्ट`)
};

const pt_pt2_style_guide_export_report_aria_label = /** @type {(inputs: Style_Guide_Export_Report_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatório de Exportação`)
};

/**
* | output |
* | --- |
* | "Export Report" |
*
* @param {Style_Guide_Export_Report_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_export_report_aria_label = /** @type {((inputs?: Style_Guide_Export_Report_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Export_Report_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_export_report_aria_label(inputs)
	if (locale === "de") return de_style_guide_export_report_aria_label(inputs)
	if (locale === "it") return it_style_guide_export_report_aria_label(inputs)
	if (locale === "ru") return ru_style_guide_export_report_aria_label(inputs)
	if (locale === "es") return es_style_guide_export_report_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_export_report_aria_label(inputs)
	if (locale === "ja") return ja_style_guide_export_report_aria_label(inputs)
	if (locale === "hi") return hi_style_guide_export_report_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_export_report_aria_label(inputs)
	return en_style_guide_export_report_aria_label(inputs)
});